import { APP_CONFIG } from '@/config';
import { from, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import AES from 'crypto-js/aes';
import ENC from 'crypto-js/enc-utf8';

const key = ENC.parse('0dd50513030f2eb95019752a8ccf2146');
const iv = ENC.parse('2def2d7efc5b5c48');

/** crypto-js 加密 / 解密服务 */
class CryptoService {

  /** 是否开启接口加密 */
  isEnable = true;

  /** 接口请求的key  md5-16位 fnw */
  requestKey = 'e2fc343423357fb4';

  /** 接口返回值的key  md5-16位 fnw */
  responseKey = 'e2fc343423357fb4';
  
  /** 加密 */
  encrypt(params: any) {
    const data = JSON.stringify(params);
    return AES.encrypt(data, key, {iv}).toString();
  }

  /** 解密 */
  decrypt(params: string) {
    const decryptedData = AES.decrypt(params, key, {iv}).toString(ENC)
    return JSON.parse(decryptedData);
  }
}
/** crypto-js 加密 / 解密服务 */
export const cryptoService =  new CryptoService();